import { BrokerAgreementSummary } from '../../../../../../queries/brokerAgreementQueries';
import { BrokerName } from './components/BrokerName';
import { BrokerAddress } from './components/BrokerAddress';
import { BrokerContact } from './components/BrokerContact';
import { CardSectionLabel } from '../../../../../CardSectionLabel';

/** The agreement's broker: name, business, address and contact details. */
export const AgreementBrokerDetails = ({ broker }: { broker: NonNullable<BrokerAgreementSummary['broker']> }) => {
    return (
        // Two parts of the card's row to the borrower's three (overrides borrowerSelectorCardColumns' equal columns)
        <div style={{ flex: '2 1 0' }}>
            <CardSectionLabel>Broker:</CardSectionLabel>
            <BrokerName broker={broker} />
            <BrokerAddress broker={broker} />
            <BrokerContact broker={broker} />
        </div>
    );
};
